<template>
  <div class="row">
    <div class="col-md-12" v-if="kpiObj !== null">
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-around">
            <!-- order -->
            <div
              class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1"
              style="padding: 0.7rem;"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <h2>KPI/<span style="font-size: 17px">Order</span></h2>
                </div>
                <div>
                  <ClipboardIcon />
                </div>
              </div>
              <KeyValue
                objKey="Total Allocated Order"
                :objValue="kpiObj.total_allocationed_order"
                :showBullet="true"
              />
              <KeyValue
                objKey="Total Allocated Order Repayed Amount"
                :objValue="kpiObj.total_allocationed_order_repayed_amount"
                :showCurrency="true"
                :showBullet="true"
              />
              <KeyValue
                objKey="Total Allocated Order Balance Amount"
                :objValue="kpiObj.total_allocationed_order_balance_amount"
                :showBullet="true"
                :showCurrency="true"
              />
              <KeyValue
                objKey="Total Allocated Order Amount"
                :objValue="kpiObj.total_allocationed_order_amount"
                :showBullet="true"
                :showCurrency="true"
              />

              <KeyValue
                objKey="Pending Loans"
                :objValue="kpiObj.pending_loans"
                :showBullet="true"
                :showCurrency="false"
              />
            </div>
            <!-- order -->
            <div
              class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1"
              style="padding: 0.7rem;"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <h2>KPI/<span style="font-size: 17px">Order</span></h2>
                </div>
                <div>
                  <ClipboardIcon />
                </div>
              </div>
              <KeyValue
                objKey="Order Gap"
                :objValue="kpiObj.order_gap"
                :showBullet="true"
              />
              <KeyValue
                objKey="Completed Order Rate"
                :objValue="kpiObj.completed_order_rate"
                :showBullet="true"
                :showPercent="true"
              />
              <KeyValue
                objKey="Completed Order"
                :objValue="kpiObj.completed_order"
                :showBullet="true"
              />
              <KeyValue
                objKey="Total Running Order "
                :objValue="kpiObj.total_running_order"
                :showBullet="true"
              />

              <KeyValue
                objKey="Total Loan Refused"
                :objValue="kpiObj.total_loan_refused"
                :showBullet="true"
                :showCurrency="false"
              />
              <KeyValue
                objKey="Total Loan Refused Today"
                :objValue="kpiObj.total_loan_refused_today"
                :showBullet="true"
                :showCurrency="false"
              />
            </div>
            <!-- amount -->
            <div
              class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1"
              style="padding: 0.7rem;"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <h2>KPI/<span style="font-size: 17px">Amount</span></h2>
                </div>
                <div>
                  <CreditCardIcon />
                </div>
              </div>
              <KeyValue
                objKey="Total Repayment "
                :objValue="kpiObj.total_repayments"
                :showBullet="true"
                :showCurrency="true"
              />
              <KeyValue
                objKey="Success Repayment "
                :objValue="kpiObj.success_repayments"
                :showBullet="true"
                :showPercent="true"
              />
              <KeyValue
                objKey="Amount Repayment Rate"
                :objValue="kpiObj.amount_repayment_rate"
                :showBullet="true"
                :showPercent="true"
              />
              <KeyValue
                objKey="Amount Gap "
                :objValue="kpiObj.amount_gap"
                :showBullet="true"
                :showCurrency="true"
              />

              <KeyValue
                objKey="Awaiting Disbursement"
                :objValue="kpiObj.awaiting_disbursement"
                :showBullet="true"
                :showCurrency="false"
              />
              <KeyValue
                objKey="Total Amount Disbursed Today"
                :objValue="kpiObj.total_amounts_disbursed_today"
                :showBullet="true"
                :showCurrency="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueDataTable from "@/components/VueDataTable";
// import { mapGetters } from "vuex";
// import CCard from "@/components/CCard";
import KeyValue from "@/components/KeyValue.vue";
// import CModal from "@/components/CModal";
// import CDataTable from "../../components/CDataTable.vue";
import ApiService from "@/services/api.service";
// import Swal from "sweetalert2";
// import ErrorService from "@/services/error.service";
// import CPagination from "@/components/CPagination.vue";
import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
export default {
  name: "LoanStat",
  components: {
    // VueDataTable,
    KeyValue,
    ClipboardIcon,
    // CCard,
    // CModal,
    // CDataTable,
    // CPagination,
    CreditCardIcon
  },
  data() {
    return { kpiObj: null, kpiLoading: false };
  },
  methods: {
    async kpiStats() {
      try {
        this.kpiLoading = true;
        const res = await ApiService.get("loan/instant/kpi-stats");

        this.kpiObj = res.data.data;
        this.kpiLoading = false;
      } catch (error) {
        this.kpiLoading = false;

        // console.log(error.response);
      }
    }
  },
  mounted() {
    this.kpiStats();
  }
};
</script>

<style scoped></style>
